export const QUERY_CLIENTS = {
  APOLLO: 'apollo',
  DFC: 'data-fetching-client'
};